import type { FolderForestNode, FolderForestNodeType } from "owa-favorites-types";
import { getFolderIdForSelectedNode, getSelectedNode } from "owa-mail-folder-forest-store";
import React from "react";

export interface RetainedFolderForFavoritesSideRail {
    folderId: string;
    treeType: FolderForestNode["treeType"];
    nodeType: FolderForestNodeType;
}

export default function useRetainedFolderForFavoritesSideRail(isSideRailVisible: boolean, isFolderPaneOverlayOpen: boolean): RetainedFolderForFavoritesSideRail | undefined {
    const retainedFolderRef = React.useRef<RetainedFolderForFavoritesSideRail | undefined>(isSideRailVisible ? getSelectedFolder() : undefined);
    const wasSideRailVisibleRef = React.useRef(isSideRailVisible);
    const wasFolderPaneOverlayOpenRef = React.useRef(isFolderPaneOverlayOpen);
    const isBecomingVisible = isSideRailVisible && !wasSideRailVisibleRef.current;
    // The rail stays visible while the folder pane overlay is open, so treat the overlay
    // closing like the rail becoming visible to pick up a folder selected in the overlay.
    const isOverlayClosing = isSideRailVisible && wasFolderPaneOverlayOpenRef.current && !isFolderPaneOverlayOpen;
    const retainedFolder = !isSideRailVisible
        ? undefined
        : isBecomingVisible || isOverlayClosing
            ? getSelectedFolder()
            : retainedFolderRef.current;
    
    React.useEffect(() => {
        retainedFolderRef.current = isSideRailVisible ? retainedFolder : undefined;
        wasSideRailVisibleRef.current = isSideRailVisible;
        wasFolderPaneOverlayOpenRef.current = isFolderPaneOverlayOpen;
    }, [isSideRailVisible, isFolderPaneOverlayOpen, retainedFolder]);
    
    return retainedFolder;
}

function getSelectedFolder(): RetainedFolderForFavoritesSideRail | undefined {
    const folderId = getFolderIdForSelectedNode();
    if (!folderId) {
        return undefined;
    }
    
    const selectedNode = getSelectedNode();
    return {
        folderId,
        treeType: selectedNode.treeType,
        nodeType: selectedNode.type,
    };
}
